import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
/**
 * H5 应用的子路由配置
 * 这些是相对于 /h5 的子路由
 */
export const OpenRoutes: Array<RouteConfig> = [
    {
        path: 'open-tongue',
        name: 'openTongue',
        component: () => import('@/views/open/tongue/index.vue'),
        meta: { title: '望舌知健康' }
    },
    {
        path: 'tongue-collect',
        name: 'tongueCollect',
        component: () => import('@/views/open/tongue/collect.vue'),
        meta: { title: '望舌知健康' }
    },
    {
        path: 'tongue-report',
        name: 'tongueReport',
        component: () => import('@/views/open/tongue/result.vue'),
        meta: { title: '舌诊报告' }
    }
]
